import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '@service/authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private authenticationService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.authenticationService.checkExpiredToken();
    return next.handle(this.addAccessTokenToHttpHeader(request)).pipe(
      catchError((error: Error) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            if (window.parent.length > 0) {
              // for iframe
              window.parent.postMessage([{ channel: 'Unauthorized' }], '*');
            } else {
              this.authenticationService.clearCurrentUser();
              this.router.navigate(['renewal']);
            }
            return throwError(()=> error);
          } else {
            return throwError(()=> error);
          }
        } else {
          return throwError(()=> error);
        }
      })
    );
  }

  private addAccessTokenToHttpHeader(request: HttpRequest<any>): HttpRequest<any> {
    return request.clone({
      headers: this.authenticationService.getHttpHeader()
    });
  }
}
